/* eslint-env browser */
import { ActionType } from 'redux-promise-middleware'
import {
  CONTENT_TYPE,
  REHYDRATED
} from '../actions'
import inDOM from 'dom-helpers/canUseDOM'
import {
  getPageTitle
} from '../selectors'

export default store => next => action => {
  if (!inDOM) return next(action)

  window.dataLayer = window.dataLayer || []

  const ret = next(action)
  switch (action.type) {
    case `${CONTENT_TYPE}_${ActionType.Fulfilled}`:
    case REHYDRATED: {
      const title = getPageTitle(store.getState())
      window.dataLayer.push({
        event: 'pageview',
        page: window.location.pathname,
        title
      })
      break
    }
    // no default
  }

  return ret
}
